export const FETCH_GALLERY = "FETCH_GALLERY";
export const FETCH_GALLERY_FAILURE = "FETCH_GALLERY_FAILURE";
export const FETCH_GALLERY_SUCCESS = "FETCH_GALLERY_SUCCESS";
